import React, { useEffect, useContext } from 'react';
import Panel from 'components/common/panel/panel';
import Datatable from 'components/common/datatable/datatable';
import AppContext from 'contexts/appContext';
import Pager from 'components/common/pager/pager';

export default function DashboardPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Boarding, 'Dashboard');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Dashboard', selected: true }]);
  }, []);

  return (
    <div className='row justify-content-md-center mx-0 mt-4'>
      <div className='col-md-12 col-xl-10'>
        <Panel>
          <Panel.Header>Dashboard</Panel.Header>
          <Panel.Body>
            <Datatable columns={columns} data={data} />
            <Pager active={3} pages={50} onChange={(page) => null} />
            <div className='text-right mt-1'>Total records: 5,123</div>
          </Panel.Body>
        </Panel>
      </div>
    </div>
  );
}

const columns = [
  {
    Header: 'Site',
    accessor: 'storeName',
    sticky: 'left',
    width: 220,
  },
  {
    Header: 'Agent Status',
    accessor: 'swStatus',
    indicator: [
      {
        equals: 'Good',
        color: '#008000',
      },
      {
        equals: 'Warning',
        color: '#ea901f',
      },
      {
        equals: 'Error',
        color: '#c52f2f',
      }
    ],
    badge: [
      {
        equals: 'Good',
        color: '#008000',
        textColor: '#ffffff',
      },
      {
        equals: 'Warning',
        color: '#ea901f',
        textColor: '#ffffff',
      },
      {
        equals: 'Error',
        color: '#c52f2f',
        textColor: '#ffffff',
      }
    ],
  },
  {
    Header: 'Agent Version',
    accessor: 'swVersion',
  },
  {
    Header: 'Agent Build Date',
    accessor: 'swBuildDate',
  },
  {
    Header: 'Payments Version',
    accessor: 'hwVersion',
  },
  {
    Header: 'Mozart Agent Version',
    accessor: 'mzAgentVersion',
  },
  {
    Header: 'Mozart Plugin Version',
    accessor: 'mzPluginVersion',
  },
  {
    Header: 'Operating System',
    accessor: 'osName',
    width: 400,
    maxWidth: 600,
  },
  {
    Header: 'Progress',
    accessor: 'progress',
    progress: [
      {
        start: 0,
        end: 25,
        color: '#ed5565',
      },
      {
        start: 26,
        end: 50,
        color: '#f8ac59',
      },
      {
        start: 51,
        end: 75,
        color: '#23c6c8',
      },
      {
        start: 76,
        end: 99,
        color: '#1c84c6',
      },
      {
        start: 100,
        end: 100,
        color: '#1ab394',
      },
    ],
  },
  {
    Header: 'Connection',
    accessor: 'connection',
    progressBlocks: [
      {
        value: 1,
        color: '#ed5565',
      },
      {
        value: 2,
        color: '#f8ac59',
      },
      {
        value: 3,
        color: '#23c6c8',
      },
      {
        value: 5,
        color: '#1c84c6',
      },
      {
        value: 6,
        color: '#1ab394',
      },
    ],
  },
];

const data = [
  {
    storeName: 'Store 414 - Sanford',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 7 Professional',
    progress: 22,
    connection: 3,
  },
  {
    storeName: 'Store 419 - Clermont',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 93,
    connection: 4,
  },
  {
    storeName: 'Store 421 - Orlando (Hunter\'s Creek)',
    swStatus: 'Warning',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 77,
    connection: 2,
  },
  {
    storeName: 'Store 423 - Orlando (Lake Nona)',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 7 Professional',
    progress: 62,
    connection: 0,
  },
  {
    storeName: 'Store 424 - WATERFORD/UCE',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 50,
    connection: 6,
  },
  {
    storeName: 'Store 425 - Alamonte Springs',
    swStatus: 'Warning',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 7,
    connection: 4,
  },
  {
    storeName: 'Store 427 - Winter Park',
    swStatus: 'Warning',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 100,
    connection: 5,
  },
  {
    storeName: 'Store 501 - Tenders',
    swStatus: 'Good',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 46,
    connection: 2,
  },
  {
    storeName: 'Store 505 - Wake Forest',
    swStatus: 'Error',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 7 Professional',
    progress: 14,
    connection: 1,
  },
  {
    storeName: 'Store 506 - Falls of Neuse',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise LTSC',
    progress: 88,
    connection: 5,
  },
  {
    storeName: 'Store 507 - Concrd Mills',
    swStatus: 'Good',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.13',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 33,
    connection: 0,
  },
  {
    storeName: 'Store 508 - Cary',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 99,
    connection: 6,
  },
  {
    storeName: 'Store 509 - Columbia',
    swStatus: 'Good',
    swVersion: '8.12.3',
    swBuildDate: '12/05/2019',
    hwVersion: '2.1.6.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 0,
    connection: 4,
  },
  {
    storeName: 'Store 511 - Hickory',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 29,
    connection: 5,
  },
  {
    storeName: 'Store 512 - Durham',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 10 Enterprise 2016 LTSB',
    progress: 55,
    connection: 1,
  },
  {
    storeName: 'Store 513 - Greenville',
    swStatus: 'Good',
    swVersion: '8.13.1',
    swBuildDate: '07/15/2020',
    hwVersion: '2.1.7.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.8',
    osName: 'Microsoft Windows 7 Professional',
    progress: 37,
    connection: 4,
  },
  {
    storeName: 'Store 514 - Winston-Salem',
    swStatus: 'Good',
    swVersion: '8.12.4',
    swBuildDate: '02/21/2020',
    hwVersion: '2.1.8.0',
    mzAgentVersion: '2.1.1',
    mzPluginVersion: '2.1.1.10',
    osName: 'Microsoft Windows 10 Enterprise LTSC',
    progress: 100,
    connection: 6,
  },
];